'use client'

import GTMScripts from '@/components/Scripts/GTMScripts.script';
import Script from 'next/script';

export default function AnalyticsProvider() {
  return (
    <>
      {/* Google Tag Manager & Analytics */}
      <GTMScripts 
        gtmId="GTM-NKSMZ26F"
        ga4Id="G-YLS8T7FSRC" 
        debug={process.env.NODE_ENV === 'development'}
        loadOnInteraction={false}
      />
      
      {/* Facebook Pixel */}
      <Script
        id="facebook-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${process.env.NEXT_PUBLIC_PIXEL_APP_ID || '861209575562011'}');
            fbq('track', 'PageView');
          `
        }}
      />
    </>
  );
}